import { Step } from "@redotech/redo-model/return-flow";
import { Button, ButtonSize, ButtonTheme } from "@redotech/redo-web/button";
import { memo } from "react";
import * as informationCss from "./information.module.css";

export const InformationStep = memo(function InformationStep({
  step,
  nextClicked,
}: {
  step: Step.Information;
  nextClicked: () => void;
}) {
  return (
    <div className={informationCss.wrapper}>
      <div className={informationCss.title}>{step.header}</div>
      <div
        className={informationCss.message}
        // TODO parse HTML safely
        dangerouslySetInnerHTML={{ __html: step.message }}
      />
      <div className={informationCss.button}>
        <Button
          onClick={nextClicked}
          size={ButtonSize.MEDIUM}
          theme={ButtonTheme.PRIMARY}
          w="full"
        >
          {step.continueButtonText}
        </Button>
      </div>
    </div>
  );
});
